module.exports = __webpack_public_path__ + "static/img/激活红包.33e672a.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/激活红包.png
// module id = e0hX
// module chunks = 87